import React from 'react';
import PropTypes from 'prop-types';
import MicIcon from '@mui/icons-material/Mic';
import './review.css';

/**
 * The STT dictation toggle (spec "Voice input (STT)") — ported to the mock's
 * `.micbtn` (docs/design/specimen/review.html, #450: 26×26 square button, not
 * MUI's IconButton chrome/sizing) — a real `<button>` with `aria-pressed` + a
 * `title`, reused by both CommentComposer and ReviewFooter. Callers are
 * responsible for feature-detecting (`isSpeechRecognitionSupported()`) and not
 * rendering this at all when the API is unavailable — hidden, not
 * disabled-and-mysterious.
 *
 * The listening state is shown by colour (red) AND the caller renders a
 * visible "Listening…" text label alongside — colour alone is never the only
 * signal (spec Accessibility). The pulsing dot respects prefers-reduced-motion
 * via review.css (a media query, not JS).
 */
function MicToggleButton({ listening, onToggle, title = undefined }) {
  return (
    <button
      type="button"
      aria-pressed={listening}
      onClick={onToggle}
      title={title || (listening ? 'Stop dictation' : 'Dictate (toggle on/off)')}
      className={listening ? 'micbtn rmdv-mic-btn rmdv-mic-on on' : 'micbtn rmdv-mic-btn'}
      data-testid="mic-toggle"
    >
      <MicIcon className="ic" sx={{ fontSize: 14 }} />
    </button>
  );
}

MicToggleButton.propTypes = {
  listening: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default MicToggleButton;
